(() => {
  if (window.gfMobileProductLoaded) return;
  window.gfMobileProductLoaded = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const initialized = new WeakSet();
  const init = (root = document) => {
    root.querySelectorAll('product-info.gf-mobile-product').forEach((section) => {
      if (initialized.has(section)) return;
      initialized.add(section);
      const gallery = section.querySelector('.product__media-list');
      let pointer = null;
      let suppressUntil = 0;
      let returnState = null;
      if (gallery) {
        gallery.addEventListener('gf:gallery-change', (event) => {
          if (returnState) returnState.left = event.detail.left;
        });
        gallery.addEventListener('pointerdown', (event) => {
          if (!mobile.matches) return;
          if (pointer) { pointer.moved = true; suppressUntil = Date.now() + 800; return; }
          pointer = { id: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
          suppressUntil = 0;
        }, { passive: true });
        gallery.addEventListener('pointermove', (event) => {
          if (pointer && (Math.abs(event.clientX - pointer.x) > 10 || Math.abs(event.clientY - pointer.y) > 10)) pointer.moved = true;
        }, { passive: true });
        const endPointer = (event) => {
          if (pointer && (pointer.moved || event.type === 'pointercancel')) suppressUntil = Date.now() + 800;
          pointer = null;
        };
        gallery.addEventListener('pointerup', endPointer, { passive: true });
        gallery.addEventListener('pointercancel', endPointer, { passive: true });
        gallery.addEventListener('dragstart', (event) => { if (mobile.matches && event.target.tagName === 'IMG') event.preventDefault(); });
        gallery.addEventListener('click', (event) => {
          if (!mobile.matches || !event.target.closest('modal-opener')) return;
          if (event.detail !== 0 && Date.now() < suppressUntil) {
            event.preventDefault(); event.stopImmediatePropagation(); return;
          }
          returnState = { x: window.scrollX, y: window.scrollY, left: gallery.scrollLeft };
        }, true);
        document.body.addEventListener('modalClosed', () => {
          if (!returnState) return;
          const state = returnState;
          returnState = null;
          requestAnimationFrame(() => {
            gallery.scrollTo({ left: state.left, behavior: 'instant' });
            window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
          });
        });
      }
      let scheduled = false;
      const updateGate = () => {
        scheduled = false;
        const form = section.querySelector('product-form');
        const submit = form?.querySelector('.product-form__submit');
        const personalize = form?.querySelector('.product-personalizer .ptc_button');
        if (!form || !submit) return;
        let waiting = form.querySelector('.gf-personalization-wait');
        if (!waiting && personalize) {
          const template = section.querySelector('template[data-gf-wait]');
          if (!template) return;
          waiting = template.content.firstElementChild.cloneNode(true);
          submit.insertAdjacentElement('afterend', waiting);
        }
        if (!waiting) return;
        const show = !!personalize && (submit.classList.contains('pplr_hide') || getComputedStyle(submit).display === 'none');
        if (waiting.hidden === show) waiting.hidden = !show;
      };
      const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(updateGate); } };
      new MutationObserver(schedule).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'disabled'] });
      mobile.addEventListener('change', schedule);
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', () => init());
})();
